import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'vex-froala-editor',
    templateUrl: './froala-editor.component.html',
    styleUrls: ['./froala-editor.component.scss'],
    standalone: false
})
export class FroalaEditorComponent {
  @Input() model: string = '';
  @Output() modelChange = new EventEmitter<string>();

  options: Object = {
    charCounterCount: true,
    width: '100%',
    toolbarButtons: {
      'moreText': {
        'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'clearFormatting']
      },
      'moreParagraph': {
        'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'formatOL', 'formatUL', 'paragraphFormat', 'lineHeight', 'outdent', 'indent', 'quote']
      },
      'moreRich': {
        'buttons': ['insertLink', 'insertTable', 'emoticons', 'specialCharacters'],
        'buttonsVisible': 4
      },
      'moreMisc': {
        'buttons': ['undo', 'redo', 'fullscreen', 'spellChecker', 'selectAll', 'html', 'help'],
        'align': 'right',
        'buttonsVisible': 2
      }
    },
    attribution: false
  };

  onFroalaModelChange($event: any) {
    this.modelChange.emit($event);
  }
}
